import { Component, Input, inject, ChangeDetectionStrategy} from '@angular/core';
import { Option, SingleSelectDropdownComponent } from '@cumlaude/shared-components-inputs';
import { QueryParamStateService } from '../services/query-param-state.service';

@Component({
	selector: 'app-onderwijsresultaten-uitsluiten-filter',
	templateUrl: './onderwijsresultaten-uitsluiten-filter.component.html',
	styleUrls: ['./onderwijsresultaten-uitsluiten-filter.component.scss'],
	imports: [SingleSelectDropdownComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnderwijsresultatenUitsluitenFilterComponent {
	private readonly qp = inject(QueryParamStateService);

	@Input()
	isLeerlingen: boolean = true;

	uitsluiten!: boolean;

	leerlingOptions = [new Option<boolean>(true, 'Minimaal 20 leerlingen'), new Option<boolean>(false, 'Alle')];
	cijferOptions = [new Option<boolean>(true, 'Minimaal 30 cijfers'), new Option<boolean>(false, 'Alle')];

	constructor() {
		this.qp.observe('or-uitsluiten').subscribe((meetellen) => (this.uitsluiten = meetellen));
	}

	getSelectedOption(): Option<boolean> {
		const options = this.isLeerlingen ? this.leerlingOptions : this.cijferOptions;
		return options.find(({ value }) => value === this.uitsluiten)!;
	}

	selectOption(optie: boolean) {
		this.uitsluiten = optie;
		this.qp.dispatch('or-uitsluiten', optie);
	}
}
